import React from 'react';
import './toggleswitch.css';

type Props = {
    isToggled : boolean;
    name      : string;

    onChange : (value : boolean) => void;
};

export class ToggleSwitch extends React.Component<Props> {
    constructor(props : Props) {
        super(props);
        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle() {
        this.props.onChange(!this.props.isToggled);
    }

    render() {
        return (
          <div className="toggle-row">
              <label className="labelStyle" htmlFor="steps">{ this.props.name }</label>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={this.props.isToggled}
                  onChange={this.handleToggle}
                />
                <span className="switch" />
              </label>
          </div>
        );
    }
}

